import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, PlusCircle, CalendarDays, Zap, Users } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    { id: 'hub', labelKey: 'nav.hub', icon: LayoutDashboard, path: '/hub' },
    { id: 'create', labelKey: 'nav.createEdit', icon: PlusCircle, path: '/create' },
    { id: 'calendar', labelKey: 'nav.calendar', icon: CalendarDays, path: '/calendar' },
    { id: 'get-it-done', labelKey: 'nav.todoLists', icon: Zap, path: '/get-it-done' },
    { id: 'directory', labelKey: 'nav.connections', icon: Users, path: '/directory' },
  ];

  const isActive = (item) => location.pathname === item.path;

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-40 bg-card border-t shadow-lg bottom-nav-container"
      style={{ transform: 'none', isolation: 'isolate' }}
      data-testid="bottom-nav"
    >
      <div className="max-w-lg mx-auto px-2">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            return (
              <button
                key={item.id}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all duration-200 min-w-[60px] touch-manipulation ${
                  active ? 'text-primary bg-primary/10' : 'text-foreground hover:bg-muted/50'
                }`}
                data-testid={`bottom-nav-${item.id}`}
              >
                <Icon className={`h-5 w-5 ${active ? 'scale-110' : ''} transition-transform`} />
                <span className={`text-[10px] mt-1 font-medium ${active ? 'text-primary' : ''}`}>
                  {t(item.labelKey)}
                </span>
              </button>
            );
          })}
        </div>
      </div>
      <div className="h-safe-area-inset-bottom bg-card" />
    </nav>
  );
};

export default BottomNav;
